import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import MetaData from '../Layouts/MetaData';
import BackdropLoader from '../Layouts/BackdropLoader';
import { useLang } from '../../utils/i18n';

// One reusable viewer for all 4 legal pages, driven by :slug in the route
// (privacy-policy / terms-conditions / refund-policy / cookie-policy).
const LegalPageView = () => {
    const { slug } = useParams();
    const { lang } = useLang();
    const [page, setPage] = useState(null);

    useEffect(() => {
        const fetchPage = async () => {
            setPage(null);
            try {
                const { data } = await axios.get(`/api/v1/legal-page/${slug}`);
                setPage(data.page);
            } catch (error) {
                console.error('Failed to load page', error);
            }
        };
        fetchPage();
    }, [slug]);

    if (!page) return <BackdropLoader />;

    const displayTitle = lang === 'zh' && page.titleZh ? page.titleZh : page.title;
    const displayBody = lang === 'zh' && page.bodyHtmlZh ? page.bodyHtmlZh : page.bodyHtml;

    return (
        <>
            <MetaData title={`${displayTitle} | 1313 Mart`} />
            <main className="w-full sm:w-[75%] m-auto mt-16 sm:mt-8 mb-16 px-3 sm:px-0">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2" dangerouslySetInnerHTML={{ __html: displayTitle }} />
                <p className="text-sm text-gray-400 mb-8">Last updated: {new Date(page.updatedAt).toLocaleDateString()}</p>
                <div className="flex flex-col gap-4 text-sm sm:text-base text-gray-600 leading-relaxed [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-gray-800 [&_h3]:mt-2 [&_ul]:list-disc [&_ul]:list-inside" dangerouslySetInnerHTML={{ __html: displayBody }} />
            </main>
        </>
    );
};

export default LegalPageView;
